import { Outlet } from "react-router-dom";

export default function AdminPage() {
    return (
        <Outlet />
    )
}